export default __webpack_public_path__ + "static/media/parkingplace1.15a98c06.jpg";